import { Col, Image, Row } from 'antd';
import dayjs from 'dayjs';
import { StatusBadge } from 'features/Dashboard/ui/StatusBadge';
import { Fragment } from 'react';
import { formatUtcToLocal } from 'routes/utils';

export const DocumentsDetails = ({ user }: any) => {
  return (
    <Fragment>
      <div className='p-2 mb-4'>
        <Row gutter={[16, 16]}>
          <Col
            span={2}
            className='hd_media mr-2 ant-col-xs-7 ant-col-lg-2 !p-0'
            style={{ background: '#dce0e6' }}
          >
            <Image
              className='object-cover'
              height={'100%'}
              src={
                user?.CompanyImage ||
                'https://www.strasys.uk/wp-content/uploads/2022/02/Depositphotos_484354208_S.jpg'
              }
            />
          </Col>
          <Col>
            <h1 className='font-bold text-xl mb-1'>Welcome {user?.Name}</h1>
            <p className='text-sm mb-1'>
              {user?.BusinessName}
              <StatusBadge status={user?.DocumentStatus} />
            </p>

            <p className='text-xs text-gray-500 mt-2'>
              {/* {dayjs(user?.LastUpdated).format('DD-MM-YYYY HH:mm A')} */}
              {formatUtcToLocal(
                dayjs(user?.lastUpdatedDate).format('DD-MMM-YYYY'),
              )}
            </p>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};
